<template>
  <div class="flex-fill">
    <div class="d-md-inline-flex mb-3 align-items-baseline">
      <div class="d-flex align-items-baseline">
        <div class="key mr-2 ticket-details">{{ $t("global.status") }}:</div>
        <Pill
          v-if="ticket.status"
          :content="ticket.status.identity"
          :variant="getTicketStatusColor(ticket)"
        />
      </div>
      <div class="spacer mx-3 d-none d-sm-none d-md-block">|</div>
      <div class="d-flex align-items-baseline">
        <div class="key mr-2 ticket-details">{{ $t("global.priority") }}:</div>
        <Pill
          v-if="ticket.priority"
          :content="ticket.priority.identity"
          :variant="getTicketPriorityColor(ticket)"
        />
      </div>
      <div class="spacer mx-3 d-none d-sm-none d-md-block">|</div>
      <div v-if="ticket.department" class="d-flex align-items-baseline">
        <div class="key mr-2 ticket-details">{{ $t("global.department") }}:</div>
        <div class="value">{{ ticket.department.identity }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTicketPriorityColor, getTicketStatusColor } from "@/utils/useTickets";
import { canWrite } from "@/utils/useAuth";
import Pill from "@/components/display/Pill";

export default {
  name: "TicketBanner",
  components: {
    Pill,
  },
  props: {
    ticket: Object,
  },
  setup() {
    return {
      canWrite,
      getTicketPriorityColor,
      getTicketStatusColor,
    };
  },
};
</script>

<style lang="scss" scoped>
.key {
  font-size: 0.75rem;
}
.value {
  font-weight: bold;
  font-size: 0.875rem;
}
</style>
